import React, { useEffect, useState, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { ThreadCard, SearchInput } from "../components/Components";
import {
  getListOfTopics,
  getListOfChannels,
} from "../service/blackbox-service";
import { getPresignedImage } from "../service/global-service";
import BlackboxIcon from "../assets/icons/BlackboxIcon.png";
import debounce from "lodash.debounce";
import GeneralCompanyImage from "../assets/images/company.png";

const MainChatList = () => {
  const [companyId, setCompanyId] = useState(null);

  const renderCount = useRef(0);

  const [isBookingParty, setIsBookingParty] = useState(null);

  const [token, setToken] = useState(null);

  const [listingType, setListingType] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [topicList, setTopicList] = useState([]);

  const [tempTopicList, setTempTopicList] = useState([]);

  const history = useHistory();

  useEffect(() => {
    getListOfUserTopics();
  }, [renderCount.current]);

  const { search } = useLocation();

  const getImage = async (image, token) => {
    let result = await getPresignedImage({
      token: token,
      image: image,
    });

    if (result.status === 200) {
      const {
        data: {
          data: { presigneUrl },
        },
      } = result;

      return presigneUrl;
    } else {
      return GeneralCompanyImage;
    }
  };

  const getListOfUserTopics = async () => {
    setIsLoading(true);
    const query = new URLSearchParams(search);

    if (query?.get("companyId")?.length !== 0) {
      setCompanyId(query.get("companyId"));
      setIsBookingParty(query.get("isBookingParty"));
      setListingType(query.get("listingType"));
      setToken(query.get("token"));

      if (query.get("topicId")) {
        let payload = {
          memberId: query.get("companyId"),
          topic: query.get("topicId"),
        };
        if (query.get("roleAs")) {
          payload["roleAs"] = query.get("roleAs");
        }

        let result = await getListOfChannels(payload);

        try {
          if (result.status === 200) {
            setIsLoading(false);
            const {
              data: { data: channels },
            } = result;

            let allChat = channels.filter(
              (channel) => channel.information.chatHeads === "All"
            );
            if (allChat && query.get("reservationId")) {
              let allPayload = {
                memberId: query.get("companyId"),
                topic: query.get("reservationId"),
              };
              let allResult = await getListOfChannels(allPayload);

              try {
                if (allResult.status === 200) {
                  const {
                    data: { data: reservationAll },
                  } = allResult;
                  allChat = allChat.map((data) => {
                    let rest = reservationAll.filter(
                      (all) => all.channel === data.channel
                    );
                    return { ...rest[0] };
                  });
                }
              } catch {}
            }

            let mappedChannels = validateMappHead(channels, allChat);
            if (mappedChannels.length !== 0) {
              mappedChannels[0].isActive = true;
            }

            new Promise((resolve, reject) => {
              mappedChannels.forEach((mc, index) => {
                mc.members.forEach(async (mmc, idx) => {
                  if (mmc.data.imageUrl && mmc.data.imageUrl.length !== 0) {
                    mmc.data.imageUrl = await getImage(
                      mmc.data.imageUrl,
                      query.get("token")
                    );
                  }
                });

                if (index === mappedChannels.length - 1) {
                  resolve();
                }
              });
            });

            history.push({
              pathname: "/chat",
              state: {
                channels: mappedChannels,
                memberId: query.get("companyId"),
                topic: query.get("topicId"),
                isBookingParty: query.get("isBookingParty"),
                companyName: query.get("companyName"),
                token: query.get("token"),
                reservationId: query.get("reservationId"),
                tripId: query.get("tripId"),
                fullName: query.get("fullName"),
                userName: query.get("userName"),
                userEmail: query.get("userEmail"),
                userId: query.get("userId"),
                roleAs: query.get("roleAs"),
                isAgency: query.get("isAgency"),
                createdOn: query.get("createdOn"),
                associate: query.get("associate"),
                isSameSC: query.get("isSameSC"),
              },
            });
          }
        } catch (error) {
          setIsLoading(false);
          console.warn(error);
        }
      } else {
        setIsLoading(true);

        let tempRole = query.get("roleAs");

        let filters = [
          {
            key: "description",
            value: query.get("listingType")?.split(","),
          },
        ];

        if (query.get("filter") === "true") {
          filters.push({
            key: "serviceType",
            value: query.get("serviceType").split(","),
          });
        }

        const payload = {
          memberId: query.get("companyId"),
          topic: "",
          filters,
        };

        if (tempRole != null) {
          payload["roleAs"] = tempRole;
        }

        const result = await getListOfTopics(payload);

        if (result.status === 200) {
          setIsLoading(false);
          let {
            data: {
              data: { topics },
            },
          } = result;

          let mappedRes = topics.map((topic) => {
            let searchKey;

            if (query.get("listingType") === "Trip Ticket Channel") {
              searchKey = `${topic.information.parentId} > ${topic.name}`;
            } else {
              searchKey = topic.name;
            }

            return {
              ...topic,
              searchKey,
            };
          });
          setTopicList([...mappedRes]);
          setTempTopicList([...mappedRes]);
        } else {
          setIsLoading(false);
          setTopicList([]);
          setTempTopicList([]);
        }
      }
    }
  };

  const validateMappHead = (channels, allChat) => {
    return channels.map((channel) => {
      if (allChat && allChat.length > 0) {
        let all = allChat.filter(
          (data) =>
            channel.channel === data.channel &&
            data.information.chatHeads === channel.information.chatHeads
        );
        if (all.length > 0) {
          return {
            header: all[0].channel,
            notification: 0,
            isActive: false,
            chatHeader: "",
            serviceHeader: "",
            ...all[0],
          };
        }
        return {
          header: channel.channel,
          notification: 0,
          isActive: false,
          chatHeader: "",
          serviceHeader: "",
          ...channel,
        };
      }
      return {
        header: channel.channel,
        notification: 0,
        isActive: false,
        chatHeader: "",
        serviceHeader: "",
        ...channel,
      };
    });
  };

  const searchArray = (value) => {
    let filteredResults = tempTopicList.filter((topic) =>
      topic.searchKey.toLowerCase().includes(value.toLowerCase())
    );
    /* Sender Name Search */
    if (filteredResults.length === 0) {
      filteredResults = tempTopicList.filter((topic) =>
        topic?.information?.lastMessage?.senderName
          ?.toLowerCase()
          .includes(value.toLowerCase())
      );
    }
    /* Last message Search */
    if (filteredResults.length === 0) {
      filteredResults = tempTopicList.filter((topic) =>
        topic?.information?.lastMessage?.message
          ?.toLowerCase()
          .includes(value.toLowerCase())
      );
    }

    /* Reservation ID Search */
    if (filteredResults.length === 0) {
      filteredResults = tempTopicList.filter((topic) =>
        topic?.information?.parentId
          ?.toLowerCase()
          .includes(value.toLowerCase())
      );
    }

    setTopicList([...filteredResults]);
  };

  const delayInput = debounce(searchArray, 500);

  return (
    <div className="flex flex-col gap-4 items-center py-8 px-4 min-h-screen min-w-full">
      <div className="w-full flex flex-row items-center justify-center">
        <img src={BlackboxIcon} alt="Blackbox" />
      </div>
      <div className="px-2 w-full pb-4">
        <SearchInput onChange={delayInput} />
      </div>
      {!isLoading ? (
        <div className="flex-grow h-full w-full overflow-hidden relative">
          <div className="absolute top-0 left-0 right-0 bottom-0 overflow-y-auto">
            {topicList.length !== 0 ? (
              topicList
                .filter((e) => e.information?.lastMessage?.timestamp)
                .sort((a, b) =>
                  new Date(a.information.lastMessage?.timestamp).getTime() <
                  new Date(b.information.lastMessage?.timestamp).getTime()
                    ? 1
                    : -1
                )
                .map((topic) => (
                  <ThreadCard
                    setIsLoading={setIsLoading}
                    topic={topic}
                    key={topic.name}
                    memberId={companyId}
                    isBookingParty={isBookingParty}
                    token={token}
                    listingType={listingType}
                  />
                ))
            ) : (
              <>No Data Found</>
            )}
          </div>
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center h-160">
          <svg
            role="status"
            className="inline w-22 h-16 mr-2 text-gray-200 animate-spin dark:text-gray-600 "
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="#243c5a"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export default MainChatList;
